import { FC } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { Accordion } from '@bphxd/ds-core-react';

/**
 * This is temporary footer component. Need to finetune this later along with correct links
 */
const Footer: FC = () => {
  const headingSize = 'fs-base';

  const nav1 = {
    title: 'Maintenance Planning',
    content: (
      <Nav vertical>
        <NavItem>
          <NavLink
            href="https://portal.bpglobal.com"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            SAP Fiori
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="https://app.aize.io/"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            Aize - 3D Visualisation Twin
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="https://bpenergycompany.kanbanize.com/ctrl_board/79"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            Kanbanize
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="https://bpcompany.lightning.force.com/lightning/page/home"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            AIW
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="https://ecowns.bpweb.bp.com/login?return_url=./"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            eCoW
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="https://apps.powerapps.com/play/e/default-ea80952e-a476-42d4-aaf4-5457852b0f7e/a/396539f3-f346-4bca-bf2e-af2c321b72f9?tenantId=ea80952e-a476-42d4-aaf4-5457852b0f7e&source"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            eSCR
          </NavLink>
        </NavItem>
      </Nav>
    ),
  };

  const nav2 = {
    title: 'Dashboards and Reports',
    content: (
      <Nav vertical>
        <NavItem>
          <NavLink
            href="https://bp.eu-1.celonis.cloud/package-manager/ui/views/ui/spaces/e2795fff-af87-4560-ba47-33dd8e43bb73/nodes/b45d2bb0-17c4-4eaa-980f-0e1bf8701f66#!/documents/b45d2bb0-17c4-4eaa-980f-0e1bf8701f66/view"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            Celonis
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="https://anw.bpweb.bp.com/"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            PM Forecasting Tool
          </NavLink>
        </NavItem>
      </Nav>
    ),
  };
  const nav3 = {
    title: 'Support',
    content: (
      <Nav vertical>
        <NavItem>
          <NavLink
            href="https://myit.bpglobal.com/myit"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            MyIT Form
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="/faq"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            Companion App FAQ
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
            onClick={(e) => {
              e.preventDefault();
              window.open('https://digitalfeedback.bpglobal.com/feedback_gui/_BLEQJVi', '_blank','popup,width=450,height=800')
            }}
          >
            Leave Feedback
          </NavLink>
        </NavItem>
      </Nav>
    ),
  };
  const nav4 = {
    title: 'About',
    content: (
      <Nav vertical>
        <NavItem>
          <NavLink
            href="https://bp365.sharepoint.com/sites/TransformationAndIntegrationHub/SitePages/bpTwin.aspx?xsdata=MDV8MDJ8Sk9TSFVBLkVMTElTT05AYnAuY29tfDk4YjU0YTgwZGNhMjQwNzQ4NWM2MDhkYzdmZmEwNGE1fGVhODA5NTJlYTQ3NjQyZDRhYWY0NTQ1Nzg1MmIwZjdlfDB8MHw2Mzg1MjU5NTkxOTYxNTExNjh8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpXSWpvaU1DNHdMakF3TURBaUxDSlFJam9pVjJsdU16SWlMQ0pCVGlJNklrMWhhV3dpTENKWFZDSTZNbjA9fDB8fHw%3d&sdata=Y2N0TDRGTDhsREVhNThtUGs4RTRydC8yQllSWXRFekN3aGxJWkpUNEcxRT0%3d&clickparams=eyAiWC1BcHBOYW1lIiA6ICJNaWNyb3NvZnQgT3V0bG9vayIsICJYLUFwcFZlcnNpb24iIDogIjE2LjAuMTc0MjUuMjAyMzYiLCAiT1MiIDogIldpbmRvd3MiIH0%3D"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            Virtual Asset Management
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="https://bp365.sharepoint.com/:u:/r/sites/Connectedbp2.0/SitePages/Digital-Twin-Companion-App.aspx?csf=1&web=1&share=EREI3fWK3sBEpwKxtxBCMasBNyMHjNNcx38CxHCxwk4w2A&e=5SlZtL"
            target="_blank"
            className={`${headingSize} small fw-normal px-0 py-2`}
          >
            Companion App Backlog
          </NavLink>
        </NavItem>
      </Nav>
    ),
  };

  return (
    <footer className="bg-footer">
      <section className="py-5 pt-md-11 pb-md-8">
        <div className="container">
          <div className="row d-none d-md-flex">
            <div className="col-md-3 mb-6">
              <h5 className={headingSize}>{nav1.title}</h5>
              {nav1.content}
            </div>
            <div className="col-md-3 mb-6">
              <h5 className={headingSize}>{nav2.title}</h5>
              {nav2.content}
            </div>
            <div className="col-md-3 mb-6">
              <h5 className={headingSize}>{nav3.title}</h5>
              {nav3.content}
            </div>
            <div className="col-md-3 mb-6">
              <h5 className={headingSize}>{nav4.title}</h5>
              {nav4.content}
            </div>
          </div>
          <Accordion className="d-md-none">
            <Accordion.Item>
              <Accordion.Header targetId="1" title={nav1.title} />
              <Accordion.Body accordionId="1">{nav1.content}</Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header targetId="2" title={nav2.title} />
              <Accordion.Body accordionId="2">{nav2.content}</Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header targetId="3" title={nav3.title} />
              <Accordion.Body accordionId="3">{nav3.content}</Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
              <Accordion.Header targetId="4" title={nav3.title} />
              <Accordion.Body accordionId="4">{nav4.content}</Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
